import React from 'react';
import propTypes from 'prop-types';

import ZoneCollectionLayer from './ZoneCollectionLayer';

import { scriptTypes } from 'constants/scripts';
import { styleMethods } from 'dataviz/config/map';

/**
  A map layer for displaying product-rate comparison layer for a prescription.
  Comparison layers are non-interactive and may be shown underneath an interactive layer like EditingLayer.
**/
const ProductRateComparisonLayer = ({
  map,
  productValidationValues,
  script,
  scriptType
}) => {
  const styleMethod = (scriptType === scriptTypes.FERTILITY || scriptType === scriptTypes.APPLICATION)
    ? styleMethods.fertilizerRate
    : styleMethods.seedRate;
  const zoneCollectionLayer = script.zones ? (
    <ZoneCollectionLayer
      layerName='productRate'
      map={map}
      styleFunction={styleMethod.bind(null, script, productValidationValues)}
      zones={script.zones}
    />
  ) : null;

  return (
    <div className='vra-population-hybrid-layer'>
      {zoneCollectionLayer}
    </div>
  );
};

ProductRateComparisonLayer.propTypes = {
  map: propTypes.object, // Inserted by mapping/leaflet.
  productValidationValues: propTypes.object.isRequired,
  script: propTypes.object.isRequired,
  scriptType: propTypes.string.isRequired
};

export default ProductRateComparisonLayer;
